import { Component } from '@angular/core';

import { SpinnerService } from '../../services/spinner/spinner.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
    active: boolean;

    constructor(private spinnerService: SpinnerService) {
        spinnerService.active.subscribe((value) => {
            this.active = value;
        }, (error) => {
            this.active = false;
            console.error(error);
        }, () => {
            this.active = false;
        });
    }
}
